<template>
  <div class="card">
    <h4 class="margin-t-z margin-b-s">{{ $t('rsvpTrack.rsvpDetails') }}</h4>
    <!-- PICKUP -->
    <div class="label-value border-top">
      <div class="label"><i class="fa fa-map-marker-alt fa-fw"></i><span>{{ $t('rsvpTrack.pickupLoc') }}</span></div>
      <div class="value">{{ getAddress(rsvp.pickup) }}</div>
    </div>
    <!-- STOPS -->
    <div class="label-value border-top" v-for="(stop, i) in rsvp.extraStops" :key="i">
      <div class="label"><i class="fa fa-map-marker-alt fa-fw"></i><span>{{ $t('rsvpTrack.extraStop') }}</span></div>
      <div class="value">{{ `${stop.address2} ${stop.address1} ${stop.city}, ${stop.state}` }}</div>
    </div>
    <!-- DROPOFF -->
    <div class="label-value" v-if="!charter.enabled">
      <div class="label"><i class="fa fa-map-marker-alt fa-fw"></i><span>{{ $t('rsvpTrack.dropoffLock') }}</span></div>
      <div class="value">{{ getAddress(rsvp.dropoff) }}</div>
    </div>
    <!-- PICKUP TIME -->
    <div class="label-value">
      <div class="label"><i class="far fa-clock fa-fw"></i>
        <span>{{ $t('rsvpTrack.pickupTime') }}</span>
      </div>
      <div class="value">{{ pickupTime }}</div>
    </div>
    <!-- END TIME -->
    <div class="label-value" v-if="charter.enabled">
      <div class="label"><i class="far fa-clock fa-fw"></i>
        <span>{{ $t('rsvpTrack.endTime') }}</span>
      </div>
      <div class="value">{{ endTime }}</div>
    </div>
    <!-- FLIGHT INFO -->
    <div class="label-value" v-show="isAirportPickup">
      <div class="label"><i class="fas fa-plane fa-fw"></i><span>{{ $t('rsvpTrack.flightInfo') }}</span></div>
      <div class="value">
        <span v-if="rsvp.airline === null">{{ $t('rsvpTrack.noFlightInfo') }}</span>
        <span v-else>{{ rsvp.airline }} {{ rsvp.flightNumber }}</span>
      </div>
    </div>
    <div class="row" v-if="!charter.enabled">
      <div class="small-6 column">
        <!-- PASSENGER -->
        <div class="label-value">
          <div class="label"><i class="fa fa-user fa-fw"></i><span>{{ $t('rsvpTrack.pax') }}</span></div>
          <div class="value">{{ rsvp.passengers }}</div>
        </div>
      </div>
      <div class="small-6 column">
        <!-- LUGGAGE -->
        <div class="label-value border-left padding-left">
          <div class="label"><i class="fas fa-suitcase fa-fw"></i><span>{{ $t('rsvpTrack.luggage') }}</span></div>
          <div class="value">{{ rsvp.luggage }}</div>
        </div>
      </div>
    </div>
    <!-- SERVICE TYPE -->
    <div class="label-value">
      <div class="label"><i class="fa fa-car fa-fw"></i><span>{{ $t('rsvpTrack.serviceType') }}</span></div>
      <div class="value">{{ rsvp.serviceLabel }}</div>
    </div>
    <!-- PICKUP TYPE -->
    <div class="label-value" v-show="isMeetAndGreet">
      <div class="label"><i class="fas fa-male fa-fw"></i><span>{{ $t('rsvpTrack.pickupType') }}</span></div>
      <div class="value">
        <span>{{ $t('rsvpTrack.mng') }} (${{ rsvp.payment.pickupFee.toFixed(2) }})</span>
      </div>
    </div>
    <!-- GUEST INFORMATION -->
    <div class="label-value">
      <div class="label"><i class="fa fa-user fa-fw"></i><span>{{ $t('rsvpTrack.guestInfo') }}</span></div>
      <div class="value">{{ guestInfo }}</div>
    </div>
    <div class="row" v-if="false">
      <div class="small-6 column">
        <!-- WHEELCHAIR -->
        <div class="label-value">
          <div class="label"><i class="fas fa-wheelchair fa-fw"></i><span>{{ $t('rsvpTrack.wheelchair') }}</span></div>
          <div class="value">{{ rsvp.ada.wheelchair ? $t('rsvpTrack.yes') : $t('rsvpTrack.no') }}</div>
        </div>
      </div>
      <div class="small-6 column">
        <!-- SERVICE DOG -->
        <div class="label-value border-left padding-left select-input">
          <div class="label"><i class="fas fa-blind fa-fw"></i><span>{{ $t('rsvpTrack.serviceDog') }}</span></div>
          <div class="value">{{ rsvp.ada.serviceDog ? $t('rsvpTrack.yes') : $t('rsvpTrack.no') }}</div>
        </div>
      </div>
    </div>
    <!-- DRIVER NOTES -->
    <div class="label-value" v-if="false">
      <div class="label"><i class="far fa-sticky-note fa-fw"></i><span>{{ $t('rsvpTrack.driverNote') }}</span></div>
      <div class="value">{{ driverNotes }}</div>
    </div>
  </div>
</template>

<script type="text/javascript">
import moment from 'moment'
import featureToggle from '@/modules/api/featureToggle'

export default {
  name: 'rsvp-details',
  computed: {
    rsvp () { return this.$store.state.rsvpTrack.rsvp },
    pickupTime () {
      return moment(this.rsvp.pickupTime, 'MM/DD/YYYY ' + featureToggle.timeFormat(this, false)).format('MMMM DD, YYYY - ' + featureToggle.timeFormat(this, false))
    },
    guestInfo () {
      if (this.rsvp.guest.firstName === null || this.rsvp.guest.firstName === '') {
        return this.$t('rsvpTrack.bookForMyself')
      }
      return this.$t('rsvpTrack.bookFor') + ' ' + this.rsvp.guest.firstName + ' ' + this.rsvp.guest.lastName
    },
    isMeetAndGreet () { return this.rsvp.pickupType === 'MeetAndGreet' },
    isAirportPickup () { return this.rsvp.pickup.geofenceType === 'airport' },
    driverNotes () {
      if (this.rsvp.notes === null || this.rsvp.notes === '') {
        return this.$t('rsvpTrack.noDriverNotes')
      }
      return this.rsvp.notes
    },
    charter () { return this.$store.state.reservation.charter },
    endTime () {
      return moment(this.rsvp.pickupTime, 'MM/DD/YYYY ' + featureToggle.timeFormat(this, false))
        .add(this.rsvp.eta, 'seconds')
        .format('MMMM DD, YYYY - ' + featureToggle.timeFormat(this, false))
    },
    isLyft () { return this.rsvp.lyft && Object.keys(this.rsvp.lyft).length }
  },
  methods: {
    getAddress (location) {
      if (location.geofenceType === 'airport' &&
          location.geofenceName !== '') {
        let result = location.geofenceName
        if (location.terminal && location.terminal !== '' && location.terminal !== 'undefined') {
          result += ' - ' + this.$t('rsvpTrack.terminal') + ' ' + location.terminal
        }
        return result
      }

      let address = ''
      if (location.addressLine2 && location.addressLine2 !== '' && location.addressLine2 !== 'undefined') {
        address = address + location.addressLine2 + ' '
      }
      if (location.addressLine1) {
        address = address + location.addressLine1 + ', '
      }
      if (location.city) {
        address = address + location.city + ' '
      }
      if (location.state) {
        address = address + location.state + ' '
      }
      if (location.zip) {
        address = address + location.zip
      }

      return address
    }
  }
}
</script>

<style lang="scss" scoped>
.label-value {
  position: relative;
  padding: 10px 0;
  border-bottom: 1px solid rgba(0,0,0,0.15);
  transition: all 250ms;
  -webkit-transition: all 250ms;
  background-color: #fff;

  &.border-top { border-top: 1px solid rgba(0,0,0,0.15); }
  &.border-left { border-left: 1px solid rgba(0,0,0,0.15); }

  &.padding-left { padding-left: 10px; }

  & .label {
    font-size: 12px;
    line-height: 12px;
    color: #777;

    & > *{
      display: inline-block;
      vertical-align: middle;
    }

    & i { margin-right: 5px; }
  }

  & .value {
    font-size: 16px;
    line-height: 16px;
    margin-top: 6px;
    width: 100%;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    padding-right: 20px;
  }
}
.row{
  margin: 0!important;
}
</style>



// WEBPACK FOOTER //
// ReservationDetails.vue?b6862b6e